// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '휴온스메디텍',
  targetSheetName: '20260701',
  headerRowIndex: 4,
  headerRowCount: 1,
  dataStartRowIndex: 5,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '기준가',
    commissionNote: '비고',
    commissionRate: '2026-07',
  },
  requiredHeaders: [
    '번호',
    '제약사',
    '최종 허가',
    '분류',
    '약효분류',
    '주성분코드',
    '주성분',
    '구분',
    '보험코드',
    '생동',
    '제품명',
    '규격',
    '기준가',
    '2026-01',
    '2026-07',
    '증감',
    '대체품목',
    '비고',
  ],
});
